import React, { useRef } from "react";
import { useScrollReveal } from "../hooks";

const PILLARS = [
  {
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="3" y="3" width="8" height="8" rx="1.5" stroke="currentColor" strokeWidth="1.5"/>
        <rect x="13" y="3" width="8" height="8" rx="1.5" stroke="currentColor" strokeWidth="1.5"/>
        <rect x="3" y="13" width="8" height="8" rx="1.5" stroke="currentColor" strokeWidth="1.5"/>
        <rect x="13" y="13" width="8" height="8" rx="1.5" stroke="currentColor" strokeWidth="1.5"/>
      </svg>
    ),
    title: "Brand Identity",
    body: "Logo, visual language and brand systems that make your business instantly recognizable.",
  },
  {
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="3" y="4" width="18" height="13" rx="2" stroke="currentColor" strokeWidth="1.5"/>
        <path d="M8 20h8M12 17v3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        <path d="M7 9h4M7 12h6" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
        <circle cx="16.5" cy="9.5" r="1.5" fill="currentColor" opacity=".5"/>
      </svg>
    ),
    title: "Digital Presence",
    body: "Websites, landing pages and e-commerce stores built to convert visitors into customers.",
  },
  {
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5"/>
        <path d="M9.5 8.5L16 12l-6.5 3.5V8.5z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round"/>
      </svg>
    ),
    title: "Content & Creative",
    body: "Photography, video, social content and campaigns that stop the scroll.",
  },
  {
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M3 17l4-6 4 4 4-7 4 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <circle cx="19" cy="13" r="1.5" fill="currentColor" opacity=".5"/>
      </svg>
    ),
    title: "Performance Marketing",
    body: "Meta Ads, Google Ads, SEO and social media that puts you in front of the right audience.",
  },
];

export default function Positioning() {
  const ref = useRef(null);
  const visible = useScrollReveal(ref);

  return (
    <section id="positioning" className={"section section-border reveal-section" + (visible ? " revealed" : "")} ref={ref}>
      <div className="container">
        <div className="pos-head">
          <span className="eyebrow">Digital Marketing Agency — Mysore, India</span>
          <h2 className="h2" style={{ marginTop: 16, maxWidth: 640 }}>
            One agency. Every channel your business needs to grow.
          </h2>
          <p className="lede" style={{ marginTop: 20 }}>
            OVARD Digital is a full-service digital marketing and brand growth agency based in Mysore, Karnataka, India. We handle brand identity, web, content and paid growth for businesses across India — so everything works together instead of in isolation.
          </p>
        </div>
        <div className="pos-pillars">
          {PILLARS.map((p, i) => (
            <div className="pos-pillar reveal-child" style={{ transitionDelay: `${i * 0.1}s` }} key={p.title}>
              <span className="pos-pillar-icon">{p.icon}</span>
              <h3 className="pos-pillar-title">{p.title}</h3>
              <p className="pos-pillar-body">{p.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
